import { TypeEnum } from "../constants/enums";
import { ChannelKeyMap, TypeKeyMap } from "../constants/labels";

export const TYPES_OPTIONS = Object.entries(TypeKeyMap).map(
  ([value, label]) => ({
    label,
    value: Number(value) as TypeEnum,
  }),
);

export const CHANNEL_OPTIONS = Object.entries(ChannelKeyMap).map(
  ([value, label]) => ({
    label,
    value: label,
  }),
);

const ALL_VALUE = "All";

export const handleSelectAll = (
  valueList: string[],
  prevValue: string[],
  allOptions: { value: string }[],
  setter: (v: string[]) => void,
) => {
  const totalReal = allOptions.length;
  const isAllSelectedNow = valueList.includes(ALL_VALUE);
  const wasAllSelectedBefore = prevValue.includes(ALL_VALUE);

  if (isAllSelectedNow && !wasAllSelectedBefore) {
    setter([ALL_VALUE, ...allOptions.map((o) => o.value)]);
    return;
  }

  if (
    !isAllSelectedNow &&
    wasAllSelectedBefore &&
    valueList.length === totalReal
  ) {
    setter([]);
    return;
  }

  if (wasAllSelectedBefore && valueList.length <= totalReal) {
    setter(valueList.filter((v) => v !== ALL_VALUE));
    return;
  }

  if (valueList.length === totalReal) {
    setter([ALL_VALUE, ...valueList]);
    return;
  }

  setter(valueList);
};
